export default "__VITE_ASSET__COl6Vqbc__"